import React, { useState } from "react";
import Grid from "@mui/material/Grid";
import ProfileCard from "./ProfileCard";
import SettingsCard from "./SettingsCard";
import { Box } from "@mui/material";

export default function AccountProfile() {
  return (
    <Box height={"100vh"}>
      <Box item xs={12} md={6}>
        <img
          alt="avatar"
          style={{
            width: "100vw",
            height: "35vh",
            objectFit: "cover",
            objectPosition: "50% 50%",
            position: "relative",
          }}
          src="https://newapp.smartgrowthai.com/smart_banner.png"
        />
      </Box>
      <Grid
        container
        direction={{ xs: "column", md: "row" }}
        spacing={3}
        sx={{
          position: "absolute",
          top: "20vh",
          px: { xs: 0, md: 7 },
        }}
      >
        <Grid item md={4}>
          <ProfileCard />
        </Grid>
        <Grid item md={8}>
          <SettingsCard />
        </Grid>
      </Grid>
    </Box>
  );
}
